<script>
	import CBez from './CBez.svelte'
	import CBez3 from './CBez3.svelte'
	import CBez2Wrap from './CBez2Wrap.svelte'

	const log = console.log

 	let curves = [
		{
			a:{x:10 , y:10}
		, b:{x:10 , y:30}
		, c:{x:30 , y:10}
		, d:{x:30 , y:30}
		}
	,	{
			a:{x:70 , y:10}
		, b:{x:70 , y:30}
		, c:{x:90 , y:10}
		, d:{x:90 , y:30}
		}
	]

	//$: log(JSON.stringify(curves))

function rv() {
	return Math.round(Math.random()*90+5)
}

function addRandCBez() {
	curves = [...curves,{a:{x:rv(),y:rv()},b:{x:rv(),y:rv()},c:{x:rv(),y:rv()},d:{x:rv(),y:rv()}}]
}

function addCBez() {
	curves = [...curves,{a:{x:40,y:40},b:{x:40,y:60},c:{x:60,y:40},d:{x:60,y:60}}]
}

</script>

<svg viewbox="0 0 100 100" height="100%">
	<rect x="0" y="0" width="100" height="100" fill="none" stroke="blue"/>


	{#each curves as curve, i}
		<CBez3 points={curve} on:move={ evt => curves[i] = evt.detail } />
	{/each}


	<!-- {#each positions as pos, i}
		<Point {pos} on:move={ ev=>{positions[i]=ev.detail.pos} } />
	{/each} -->
</svg>

<button on:click={addCBez} title="new bezier">+</button>
<button on:click={addRandCBez} title="random bezier">?</button>

<style>
	button {
		display: inline-block;
		padding: 0rem 0.8rem 0.1rem 0.8rem;
		border: none;
		border-radius: 50%;
		background-color: #444444;
		color: aliceblue;
		font-size: 2rem;
		font-weight: 200;
	}
</style>